import {useCallback, useEffect, useState} from "react";

import {getPhoneVerificationCodeRemainingTime} from "@pg-mono/user";

import {usePostUserPhoneVerificationCodeMutation} from "../../user/api/post_user_phone_verification_code";
import {usePostUserPhoneVerifyMutation} from "../../user/api/post_user_phone_verify";
import {getSmsLoginError, ISmsLoginCredentials, usePostSmsLoginInitMutation, usePostSmsLoginMutation} from "../api/sms_login";
import {clearSmsCodeCooldown, getSmsCodeCooldownStart, SmsCodeCooldownKind} from "../utils/registration_wizard_sms_cooldown";
import {sendRegistrationWizardSmsCode} from "../utils/send_registration_wizard_sms_code";

export interface IRegistrationWizardSmsCodeError {
    message: string;
    status: number;
}

export const useRegistrationWizardSmsCode = (smsLoginCredentials: ISmsLoginCredentials | null) => {
    const [postUserPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();
    const [postSmsLogin] = usePostSmsLoginMutation();
    const cooldownKind: SmsCodeCooldownKind = smsLoginCredentials ? "smsLogin" : "profile";
    const [cooldownStart, setCooldownStart] = useState<number | null>(() => getSmsCodeCooldownStart(cooldownKind));
    const [remainingSeconds, setRemainingSeconds] = useState(() => getPhoneVerificationCodeRemainingTime(cooldownStart));

    useEffect(() => {
        if (!cooldownStart) {
            return;
        }

        setRemainingSeconds(getPhoneVerificationCodeRemainingTime(cooldownStart));

        const intervalId = setInterval(() => {
            const remaining = getPhoneVerificationCodeRemainingTime(cooldownStart);
            setRemainingSeconds(remaining);

            if (remaining === 0) {
                clearInterval(intervalId);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [cooldownStart]);

    const sendCode = useCallback(async (): Promise<IRegistrationWizardSmsCodeError | null> => {
        const sendResult = await sendRegistrationWizardSmsCode(
            smsLoginCredentials ? postSmsLoginInit(smsLoginCredentials) : postUserPhoneVerificationCode(),
            cooldownKind
        );

        if (sendResult.error) {
            return sendResult.error;
        }

        setCooldownStart(sendResult.cooldownStart);

        return null;
    }, [smsLoginCredentials, cooldownKind, postSmsLoginInit, postUserPhoneVerificationCode]);

    const verifyCode = useCallback(
        async (code: string): Promise<IRegistrationWizardSmsCodeError | null> => {
            const response = smsLoginCredentials ? await postSmsLogin({...smsLoginCredentials, code}) : await postUserPhoneVerify({verification_code: code});

            if (response.error) {
                return getSmsLoginError(response.error, "Nie udało się zweryfikować kodu SMS.");
            }

            clearSmsCodeCooldown(cooldownKind);

            return null;
        },
        [smsLoginCredentials, cooldownKind, postSmsLogin, postUserPhoneVerify]
    );

    return {remainingSeconds, sendCode, verifyCode};
};
import {useCallback, useEffect, useState} from "react";

import {getPhoneVerificationCodeRemainingTime} from "@pg-mono/user";

import {usePostUserPhoneVerificationCodeMutation} from "../../user/api/post_user_phone_verification_code";
import {usePostUserPhoneVerifyMutation} from "../../user/api/post_user_phone_verify";
import {getSmsLoginError, ISmsLoginCredentials, usePostSmsLoginInitMutation, usePostSmsLoginMutation} from "../api/sms_login";
import {clearSmsCodeCooldown, getSmsCodeCooldownStart, SmsCodeCooldownKind} from "../utils/registration_wizard_sms_cooldown";
import {sendRegistrationWizardSmsCode} from "../utils/send_registration_wizard_sms_code";

export interface IRegistrationWizardSmsCodeError {
    message: string;
    status: number;
}

export const useRegistrationWizardSmsCode = (smsLoginCredentials: ISmsLoginCredentials | null) => {
    const [postUserPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();
    const [postSmsLogin] = usePostSmsLoginMutation();
    const cooldownKind: SmsCodeCooldownKind = smsLoginCredentials ? "smsLogin" : "profile";
    const [cooldownStart, setCooldownStart] = useState<number | null>(() => getSmsCodeCooldownStart(cooldownKind));
    const [remainingSeconds, setRemainingSeconds] = useState(() => getPhoneVerificationCodeRemainingTime(cooldownStart));

    useEffect(() => {
        if (!cooldownStart) {
            return;
        }

        setRemainingSeconds(getPhoneVerificationCodeRemainingTime(cooldownStart));

        const intervalId = setInterval(() => {
            const remaining = getPhoneVerificationCodeRemainingTime(cooldownStart);
            setRemainingSeconds(remaining);

            if (remaining === 0) {
                clearInterval(intervalId);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [cooldownStart]);

    const sendCode = useCallback(async (): Promise<IRegistrationWizardSmsCodeError | null> => {
        const sendResult = await sendRegistrationWizardSmsCode(
            smsLoginCredentials ? postSmsLoginInit(smsLoginCredentials) : postUserPhoneVerificationCode(),
            cooldownKind
        );

        if (sendResult.error) {
            return sendResult.error;
        }

        setCooldownStart(sendResult.cooldownStart);

        return null;
    }, [smsLoginCredentials, cooldownKind, postSmsLoginInit, postUserPhoneVerificationCode]);

    const verifyCode = useCallback(
        async (code: string): Promise<IRegistrationWizardSmsCodeError | null> => {
            const response = smsLoginCredentials ? await postSmsLogin({...smsLoginCredentials, code}) : await postUserPhoneVerify({verification_code: code});

            if (response.error) {
                return getSmsLoginError(response.error, "Nie udało się zweryfikować kodu SMS.");
            }

            clearSmsCodeCooldown(cooldownKind);

            return null;
        },
        [smsLoginCredentials, cooldownKind, postSmsLogin, postUserPhoneVerify]
    );

    return {remainingSeconds, sendCode, verifyCode};
};
